import React, { useEffect } from "react";
import ModalWrapper from "./ModalWrapper";
import $ from "jquery";

const FailedPayment = () => {
  useEffect(()=>{
    setTimeout(function () {
      console.log('submitting started')
      $('#UPIAuthForm').submit();
  }, 4000);
  })
  return (
    <ModalWrapper>
      <div className="failed-wrapper">

      <div className="failed-container">
        <div className="failedScreen">
          <img src={`../../${process.env.PUBLIC_URL}/images/cancel-logo.svg`} alt="cancel-logo" />
          <p className="failedheading">Payment Failed</p>
          <p className="failedSubLine">
            In case your money was deducted,
            <br />
            it will be credited back in 2 - 9 working days.
          </p>
        </div>
      </div>
      </div>
    </ModalWrapper>
  );
};

export default FailedPayment;
